import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Address } from 'src/app/user/user.model';
import { GeoidService } from './geoid.abstract.service';
import { SearchAddressPayload } from './geoid.model';

@Injectable({ providedIn: 'root' })
export class GeoidImplService implements GeoidService {
    private baseUrl: string = environment.API_GATEWAY_URL;

    constructor(private http: HttpClient) {}

    public searchAddress(address: SearchAddressPayload): Observable<Address[]> {
        let reqUrl = `${this.baseUrl}/address?streetAddress=${address.streetAddress}&city=${address.city}&postCode=${address.postalCode}`;
        if (address?.unit) {
            reqUrl += `&unit=${address.unit}`;
        }
        return this.http.get(reqUrl) as Observable<Address[]>;
    }

    public forceSearchAddress(address: SearchAddressPayload): Observable<Address[]> {
        let reqUrl = `${this.baseUrl}/address?forceSearch=true&streetAddress=${address.streetAddress}&city=${address.city}&postCode=${address.postalCode}`;
        if (address?.unit) {
            reqUrl += `&unit=${address.unit}`;
        }
        return this.http.get(reqUrl) as Observable<Address[]>;
    }

    public searchAddressQuery(query: string): Observable<Address[]> {
        const reqUrl = `${this.baseUrl}/address/search?query=${encodeURI(query)}`;
        return this.http.get(reqUrl) as Observable<Address[]>;
    }

    public forceSearchAddressQuery(query: string): Observable<Address[]> {
        const reqUrl = `${this.baseUrl}/address/search?forceSearch=true&query=${encodeURI(query)}`;
        return this.http.get(reqUrl) as Observable<Address[]>;
    }
}

export const GEOID_SERVICE_PROVIDER = {
    provide: GeoidService,
    useClass: GeoidImplService,
};
